export { default as renderCheckout } from '../app/checkout/renderCheckout';
export { default as renderOrderConfirmation } from '../app/order/renderOrderConfirmation';
